import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {Router} from 'react-router-dom';
import {createBrowserHistory} from 'history';
//MUI
import Box from '@mui/material/Box';
//RUTAS
import Routes from './Routes/Routes';
import {QueryClient, QueryClientProvider} from 'react-query';
//REDUX
import {closeMsg} from './redux-app';
//DS
import {baseName} from 'src/config/keys';
import {DialogDs, LoadingModal, Sidebar} from 'lib.front';
const browserHistory = createBrowserHistory({basename: baseName});
const queryClient = new QueryClient();

function AppDS({
   loading,
   modalProps,
   msgProps,
   overlayProps,
   sidebarProps,
   auth,
   handleCloseMsgModal
}) {
   return (
      <>
         <QueryClientProvider client={queryClient}>
            <Router basename={baseName} history={browserHistory}>
               <Routes logged={auth.logged} />
            </Router>
            <Box {...overlayProps} />
            <DialogDs {...modalProps} />
            <Sidebar {...sidebarProps} />
            <LoadingModal open={loading} />
            <DialogDs titulo="Aviso" onClose={handleCloseMsgModal} {...msgProps}></DialogDs>
         </QueryClientProvider>
      </>
   );
}
function mapStateToProps(state) {
   return {
      loading: state.loading.open,
      modalProps: state.modal,
      msgProps: state.msg,
      overlayProps: state.overlay,
      sidebarProps: state.sidebar,
      auth: state.auth
   };
}
function mapDispatchToProps(dispatch) {
   return {
      handleCloseMsgModal: () => dispatch(closeMsg())
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AppDS);
